"use client";

import { GlobalSearchProvider } from "@/components/global-search/global-search-context";
import { GlobalCommandPalette } from "@/components/global-search/global-command-palette";

export function GlobalSearchShell({ children }: { children: React.ReactNode }) {
  return (
    <GlobalSearchProvider>
      {children}
      <GlobalCommandPalette />
    </GlobalSearchProvider>
  );
}
